import { Component, OnInit, Input } from '@angular/core';
import { SidenavMenuService } from './sidenav-menu.service';
import { MenuService } from '../../../service/menu.service';
import { GrupoMenu } from '../../../domain/grupo-menu';
import { AuthService } from '../../../service/auth/auth.service';
import { NovedadService } from '../../../service/novedad.service';
import { GLOBAL } from '../../../global';
import { GenericResponse } from '../../../domain/genericResponse';

@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
  providers: [SidenavMenuService]
})
export class SidenavMenuComponent {
  @Input('menuItems') menuItems;
  @Input('menuParentId') menuParentId;
  parentMenu: Array<any>;

  public novedadesSinLeer: number;

  constructor(private sidenavMenuService: SidenavMenuService,
    private menuService: MenuService,
    public authService: AuthService,
    private novedadService: NovedadService) { }

  onClick(menuId) {
    this.sidenavMenuService.toggleMenuItem(menuId);
    this.sidenavMenuService.closeOtherSubMenus(this.menuItems, menuId);
  }

  getOpciones(): Array<GrupoMenu> {
    return this.menuService.menu;
  }
}
